import type { Middleware } from 'redux'

import { APP_NAME, getAuthToken } from '@libs/typescript-utils'

import actions from './auth/actions'
import { checkTokenExpiration } from './helpers'

const checkTokenMiddleware: Middleware<null, Store> =
  ({ dispatch, getState }) =>
  next =>
  action => {
    const result = next(action)

    const {
      auth: { isLoggedIn, renew_token_inprogress, token_expired },
    } = getState()

    if (isLoggedIn && !renew_token_inprogress) {
      const authToken = getAuthToken(APP_NAME.TMS)

      if (authToken) {
        checkTokenExpiration(dispatch, authToken)
      } else if (!token_expired) {
        dispatch(actions.expiredToken.request())
      }
    }

    return result
  }

export default checkTokenMiddleware
